module.exports = __webpack_public_path__ + "static/jirka-9a7ca275b8427de19f7922bdbcb51ad0.png";